module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_2319054.9614dfb0.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_2319054.pdf
// module id = 831
// module chunks = 0